import isEmpty from 'lodash/isEmpty';
import { listWM } from 'utils/Api';

import * as types from 'constants/ActionTypes';

function requestEducation() {
  return {
    type: types.REQUEST_EDUCATION,
    isFetching: true,
    employeeMasterEducationList: [],
    loaded: false,
    error: null,
  };
}

function requestEducationSuccess(employeeMasterEducationList) {
  return {
    type: types.REQUEST_EDUCATION_SUCCESS,
    employeeMasterEducationList,
    receivedAt: Date.now(),
    isFetching: false,
    loaded: true,
  };
}

function requestEducationFailure(error) {
  return {
    type: types.REQUEST_EDUCATION_FAILURE,
    isFetching: false,
    loaded: true,
    error,
  };
}

export function fetchEducation() {
  return (dispatch, getState) => {
    dispatch(requestEducation());

    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

    const fetchConfig = {
      entity: 'EmployeeMasterEducation',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/EmployeeMasterID eq ${EmployeeMasterID}`,
      },
    };

    listWM(fetchConfig)
      .then(({ data }) => dispatch(requestEducationSuccess(data)))
      .catch(error => dispatch(requestEducationFailure(error)));
  };
}

export function fetchEducationIfNeeded() {
  return (dispatch, getState) =>
    isEmpty(getState().educationReducer.educationData) &&
    dispatch(fetchEducation());
}



// WEBPACK FOOTER //
// ./src/actions/education.js